import React from 'react';

import PaginationBase from '../../../common/base/PaginationBase';
import global from '../../../common/utility/global';
import { message } from 'antd';
import moment from 'moment';
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';

import compraProductoService from '../../../service/logistica/compraProductoService';
import productoService from '../../../service/administracion/productoService';
import monedaService from '../../../service/administracion/monedaService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import almacenService from '../../../service/administracion/almacenService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingExcel: false,
            loadingPdf: false,
            loadingPdfRegistrado: false,
            productos: [],
            productosAll: [],
            tipoProductos: [{ id: 0, nombre: 'SELECCIONAR TIPO' }, { id: 2, nombre: 'SERVICIO' }, { id: 1, nombre: 'PRODUCTO' }],
            establecimientos: [],
            almacenes: [],
            monedas: [],
            filter: {
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                idMoneda: 0,
                idProducto: 0,
                idEstablecimiento: 0,
                idAlmacen: 0,
                idTipoProducto: 0,
                tipoReporte: 1,
                referencia: '',
                ...FILTER
            },
            columnVisible: {
                tipo: 'hide',
                serie: 'hide',
                documento: 'hide',
                fecha: 'hide',
                tipoCambio: 'hide',
                nombreCliente: 'hide',
                tipoDocumentoCliente: 'hide',
                numeroDocumentoCliente: 'hide',
                grupoConversionDolares: 'hide',
                subTotalConversionDolares: 'hide',
                igvConversionDolares: 'hide',
                totalConversionDolares: 'hide'
            },
            pagination: PAGINATION
        }
    }

    handleClearFilters = () => {
        var filter = {
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            idMoneda: 0,
            idTipoProducto: 0,
            idProducto: 0,
            idEstablecimiento: 0,
            idAlmacen: 0,
            tipoReporte: 1,
            referencia: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleChange = async (property, value) => {
     const MAX_MESES = 18;
        // Clonamos el filtro con el nuevo valor
        const filter = { ...this.state.filter, [property]: value };

        const { fechaInicioStr, fechaFinStr } = filter;

        // Solo validamos si ambas fechas existen
        if (fechaInicioStr && fechaFinStr) {
            const inicio = moment(fechaInicioStr, 'DD/MM/YYYY');
            const fin = moment(fechaFinStr, 'DD/MM/YYYY');

            const meses = fin.diff(inicio, 'months', true);

            if (meses > MAX_MESES) {
                message.error('El rango máximo permitido es de 18 meses');
                return; // ⛔ no actualiza el estado
            }
        }

        this.setState({ filter: filter });
        if (property === "idEstablecimiento") {
            this.setState({ almacenesLoading: true });
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            this.setState({
                filter: { ...this.state.filter, idAlmacen: 0 },
                almacenes: almacenes ? almacenes : [],
                almacenesLoading: false
            });
        }
        if (property === "idTipoProducto") {
            filter.idProducto = 0;
            filter.idTipoProducto = value;
            const tipoProducto = (value == 0 ? this.productos : this.state.productosAll.filter(p => p.idTipoProducto == value));
            this.setState({
                filter: filter,
                productos: tipoProducto ? tipoProducto : [],
            });
        }
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true, filter: { ...this.state.filter, flagRegistrado: false } });
        var response = await compraProductoService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Compras por Producto.xlsx");
    };

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true, filter: { ...this.state.filter, flagRegistrado: false } });
        var response = await compraProductoService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Compras por Producto.pdf");
    };

    handleExportPdfRegistrado = async () => {
        this.setState({ loadingPdfRegistrado: true, filter: { ...this.state.filter, flagRegistrado: true } });
        var response = await compraProductoService.pdf(this.state.filter);
        this.setState({ loadingPdfRegistrado: false });

        var filename = "Reporte de Compras por Producto (Registrados).pdf"

        if (this.state.filter.TipoReporte === 3)
            filename = "Reporte de Compras por Producto (Registrados Detallado).pdf"

        if (response !== undefined)
            global.dowloadFile(response.data, filename);
    };


    fetchSearch = async (value) => {
        if (value != null && value.length >= 4) {
            var lista = [];
            if (this.state.productosAll.length > 0) {
                lista = this.state.productosAll.filter((item) => {
                    return global
                        .formatSearch(`${item.nombre} - ${item.codigoReferencia}`)
                        .match(global.formatSearch(value));
                }).slice(0, 75);
            }
            if (lista.length == 0) {
                var response = await productoService.autocomplete(value)
                this.setState({
                    productosAll: response ? response : [],
                });

            } else {
                this.setState({
                    productosAll: lista ? lista : [],
                });
            }

        }
    };


    handlePagination = () => {
        this._handlePagination(this.state.filter, () => {
            this.setState({
                columnVisible: {
                    ...this.state.columnVisible,
                    precioUnitario: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    nombreCliente: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    tipoDocumentoCliente: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    numeroDocumentoCliente: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    tipo: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    serie: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    documento: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    fecha: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    tipoCambio: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',

                    grupoSoles: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    subTotalSoles: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    igvSoles: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    totalSoles: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',

                    grupoDolares: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    subTotalDolares: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    igvDolares: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    totalDolares: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',

                    grupoConversionSoles: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'hide' : 'show',
                    subTotalConversionSoles: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'hide' : 'show',
                    igvConversionSoles: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'hide' : 'show',
                    totalConversionSoles: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'hide' : 'show',

                    grupoConversionDolares: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'show' : 'hide',
                    subTotalConversionDolares: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'show' : 'hide',
                    igvConversionDolares: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'show' : 'hide',
                    totalConversionDolares: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'show' : 'hide'
                },
            })
        });
    }
    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, compraProductoService.paginacion);
        var productos = [];// await productoService.listar();
        var monedas = await monedaService.listar();
        var establecimientos = await establecimientoService.principales();

        if (monedas !== undefined)
            monedas.splice(0, 0, { id: '0', nombre: "MONEDA ORIGINAL" });

        this.setState({
            loadingSource: false,
            productos: productos ? productos : [],
            productosAll: productos ? productos : [],
            establecimientos: establecimientos ? establecimientos : [],
            monedas: monedas ? monedas : []
        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Reporte de Compras por Producto"
                    onSearch={this.handlePagination}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    productos={this.state.productosAll}
                    tipoProductos={this.state.tipoProductos}
                    establecimientos={this.state.establecimientos}
                    almacenes={this.state.almacenes}
                    monedas={this.state.monedas}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onSearch={this.fetchSearch}

                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    columnVisible={this.state.columnVisible}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPdfRegistrado={this.state.loadingPdfRegistrado}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    // onExportPdfRegistrado={this.handleExportPdfRegistrado}
                    onChange={this._handleChangePagination}
                />
            </div>
        )
    }
}